import { FormControl, FormControlLabel, Switch } from "@mui/material"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { ConfigurableDynamicFormFieldsStore } from "src/components/ConfigurableDynamicFormFields/store"
import { IConfigurableDynamicFormFieldsProps } from "src/components/ConfigurableDynamicFormFields/types/form-field"
import { useStore } from "src/store/lib/useStore"

export const ConfigurableDynamicFormFieldsBooleanField = observer(
    ({ field, sectionName }: IConfigurableDynamicFormFieldsProps) => {
        const store = useStore(ConfigurableDynamicFormFieldsStore)
        const value = store.getFieldValue(
            sectionName,
            field.name ?? "",
        ) as boolean

        const handleChange = useCallback(
            (_: unknown, checked: boolean) => {
                store.setFieldValue(sectionName, field.name ?? "", checked)
            },
            [store, sectionName, field.name],
        )

        return (
            <FormControl style={{ breakInside: "avoid" }}>
                <FormControlLabel
                    checked={Boolean(value)}
                    onChange={handleChange}
                    control={<Switch color="success" />}
                    label={field.label ?? ""}
                    sx={{ ml: 1 }}
                />
            </FormControl>
        )
    },
)
